export enum Routes {
	Dashboard = '/',
	Clients = '/clients',
	Proposals = '/proposals',
	Contracts = '/contracts',
	Invoices = '/invoices',
	Team = '/admin?tab=team',
	Vendors = '/vendors',
	CustomerFolders = '/customerFolders',
	CompanyFolders = '/companyFolders',
	MyFolder = '/myFolder',
	Resources = '/resources',
	Profile = '/profile',
	Admin = '/admin',
	Wallet = '/wallet',
	ClientUsers = '/ClientUsers',
	OrgUsers = '/OrgUsers',
	Organizations = '/Organizations',
	OrgOnboarding = '/orgOnboarding',
	ClientOnboarding = '/clientOnboarding',
	OrgMemberSignUp = '/OrgMemberSignUp',
	Timelines = '/timelines',
	Reports = '/reports',
	Leads = '/leads',
	Member = '/member',
	Files = '/files',
	Canva = '/canva',
	CanvaEdit = '/canvaEdit',
}
